/**
 * WoGridToolbarExtras — the icon cluster next to the WO grid's column
 * selector: frozen-pane dock toggle (BUG-2026-0159 follow-up) + audit-trail
 * History button (migration 110). Extracted so WorkOrdersTabContent stays
 * under the 600-line cap.
 */
import { IconButton, Tooltip } from '@mui/material';
import PushPinIcon from '@mui/icons-material/PushPin';
import PushPinOutlinedIcon from '@mui/icons-material/PushPinOutlined';
import HistoryIcon from '@mui/icons-material/History';

interface WoGridToolbarExtrasProps {
  docked: boolean;
  onToggleDock: () => void;
  onHistory: () => void;
}

export const WoGridToolbarExtras = ({ docked, onToggleDock, onHistory }: WoGridToolbarExtrasProps) => (
  <>
    <Tooltip title="Work order history — who changed what, and when">
      <IconButton size="small" onClick={onHistory}>
        <HistoryIcon fontSize="small" />
      </IconButton>
    </Tooltip>
    <Tooltip title={docked
      ? 'Undock the pinned lead columns (frees width on smaller screens)'
      : 'Pin the lead columns so Location/Sample stay visible while scrolling'}>
      <IconButton size="small" onClick={onToggleDock} color={docked ? 'primary' : 'default'}>
        {docked ? <PushPinIcon fontSize="small" /> : <PushPinOutlinedIcon fontSize="small" />}
      </IconButton>
    </Tooltip>
  </>
);
